import { FC, lazy } from 'react';
import { CreateRecordingFormProps } from '../recording-modal.types';

export const CreateRecordingBlockModalAsync = lazy<FC<CreateRecordingFormProps>>(() => import('./CreateRecordingBlockModal'));
